import { Variants } from 'framer-motion';

const mainAnimations = {
    open: {
        x: 0,
        opacity: 1,
        height: 'auto',
        transition: {
            type: 'tween' as const,
            duration: 0.25,
            ease: 'easeInOut' as const,
        },
    },
    closed: {
        x: 5,
        opacity: 0,
        transition: {
            type: 'tween' as const,
            duration: 0.25,
            ease: 'easeInOut' as const,
        },
        transitionEnd: {
            x: -5,
        },
    },
};

const containerAnimations = {
    closed: {
        opacity: 0,
        y: -5,
        transition: {
            type: 'tween' as const,
            duration: 0.2,
            ease: 'easeInOut' as const,
        },
    },
    open: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'tween' as const,
            duration: 0.45,
            ease: 'easeInOut' as const,
        },
    },
};

export const mainVariants = (prefersReducedMotion?: boolean): Variants => {
    return prefersReducedMotion ? {} : mainAnimations;
};

export const containerVariants = (prefersReducedMotion?: boolean): Variants => {
    return prefersReducedMotion ? {} : containerAnimations;
};
